// Must be set before any CSS/SCSS imports so webpack adds nonce to injected style tags
// eslint-disable-next-line no-underscore-dangle
const cspNonceValue = document.querySelector<HTMLMetaElement>('meta[name="csp-nonce"]')?.content ?? "";

// Monkey-patch createElement so that Griffel (FluentUI) style elements get the nonce property set.
// Griffel uses setAttribute("nonce", ...) which modern browsers ignore for CSP; the .nonce property must be used.
const originalCreateElement = document.createElement.bind(document);
document.createElement = ((tagName: string, options?: ElementCreationOptions) => {
    const el = originalCreateElement(tagName, options);
    if (tagName.toLowerCase() === "style" && cspNonceValue) {
        el.nonce = cspNonceValue;
    }
    return el;
}) as typeof document.createElement;

export {};
